export default `---
slug: master-polimi
type: education
dateRange: "Fall 2019 – Fall 2021"
institution: "Politecnico di Milano"
location: "Milan, Italy"
role: "MSc in Automation and Control Engineering — 110/110 cum laude"
current: false
sortKey: "2021-10"
skills: [Control Theory, Machine Learning, Python, ROS, C++, Computer Vision, Robotics, Deep Learning]
relatedLinks:
  - label: "Erasmus @ KTH"
    href: /career/erasmus-kth
  - label: "Master Thesis"
    href: /projects/master-thesis
  - label: "Automation and Control Lab"
    href: /projects/automation-control-lab
---

From fall 2019 to fall 2021, I completed my Master in Automation and Control Engineering at Politecnico di Milano, once again graduating with 110/110 cum laude. I also had a very high grade average, though not quite as high as the bachelor — because I realized I could study a little less and enjoy life more, a lesson I consider equally important.

The highlight of the master was undoubtedly the Erasmus at KTH Stockholm, which is documented separately. Because of the Erasmus, I had to take two extra courses for a total of 10 university credits — the exchange course conversion was not 1:1. It was a bit of a hustle, but it happened during COVID so I had plenty of free time.

A fun story from the master: the first semester has the most complex course of the entire 5-year cycle, "Computer Assisted Manufacturing." My notes for this class (which got me 30/30 cum laude) were transformed into a PDF by a friend, and they became the "bible" for that class — used for years by all the students. The first couple of years we even made some profits selling those notes, until the community started sharing them freely. Who cares — we still benefitted humanity.
`;
